import { createEvent, createStore } from 'effector'
import { useEvent, useStore } from 'effector-react'
// import { persist } from 'effector-storage/query'

/**
 * par: groupId
 */
export const toggleOpenedWindow = createEvent()
export const closeWindow = createEvent()
export const cancelWindow = createEvent()

export const mountGroup = createEvent()
export const unmountGroup = createEvent()

export const $isOpenedGroup = createStore<boolean>(false)
    .on(mountGroup, () => true)
    .on(unmountGroup, () => false)

export const $isOpenedFilterWindow = createStore<boolean>(false)
    .on(toggleOpenedWindow, (state) => !state)
    .on(cancelWindow, () => false)
    .reset(closeWindow)
// persist({ store: $isOpenedFilterWindow, key: 'isOpenedFilter' })

export const useToggleOpenedWindow = () => useEvent(toggleOpenedWindow)
export const useOpenedWindow = () => useStore($isOpenedFilterWindow)
export const useCancelWindow = () => useEvent(cancelWindow)

export const useMountGroup = () => useEvent(mountGroup)
export const useUnmountGroup = () => useEvent(unmountGroup)
